import { UniAnswer } from "../dao/UniAnswer";
import { GovRow } from "./GovRow";
import { HisBasic } from "./HisBasic"
import { HisRow } from "./HisRow"
import { SpwkMetaData } from "./SpwkMetaData"


export class ExportBundle {

  SourceUniAnswer: UniAnswer | null = null;

  AllMetaDataList: SpwkMetaData[] = [];

  AllHisBasicList: HisBasic[] = [];
  AllHisRowList: HisRow[] = [];

  AllGovRowList: GovRow[] = [];

  /**
   * 把匯出結果往後加入
   * 通常用於 得到單一Answer的 匯出 Bundle 後，把他加入
   */
  ConcatExportBundle(bundle: ExportBundle) {
    let re = this;

    re.AllMetaDataList = re.AllMetaDataList.concat(bundle.AllMetaDataList);

    re.AllHisBasicList = re.AllHisBasicList.concat(bundle.AllHisBasicList);
    re.AllHisRowList = re.AllHisRowList.concat(bundle.AllHisRowList);

    re.AllGovRowList = re.AllGovRowList.concat(bundle.AllGovRowList);

    return re;
  }

}

